<script>
    export default {
        props: {
            value: {
                required: true
            },
            fire: {
                type: String,
                required: true
            },
            listen: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                selected: false
            }
        },
        created() {
            EventBus.listen(this.fire, this.reAssess);
            if (this.listen) {
                EventBus.listen(this.listen, this.reAssess);
            }
        },
        methods: {
            reAssess(value) {
                this.selected = value.toString() === this.value.toString();
            },
            update() {
                this.selected = true;
                EventBus.fire(this.fire, this.value);
            }
        },
        render() {
            return this.$scopedSlots.default({
                update: this.update,
                isSelected: this.selected,
            });
        }
    }
</script>